import _ from 'lodash';
import EmailValidator from 'email-validator';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { EMAIL, SMS, CHANNEL_TYPES } from '../constants';

class NotificationPreferenceError extends Error {
}

function parseNickname(channel, profile) {
  if (channel !== EMAIL && channel !== SMS) {
    throw new NotificationPreferenceError(
      `Notification type (${channel}) can only be one of ${CHANNEL_TYPES}`
    );
  }

  const nickname = _.get(profile, 'user_metadata.nickname', '');
  if (!nickname) {
    return false
  }
  const notificationPreferences = _.split(nickname, ',');
  for (let pref of notificationPreferences) {
    if (pref === channel) {
      return true;
    }
  }
  return false;
}

function resolveNickname(emailEnabled, smsEnabled) {
  let nickname = '';

  if (emailEnabled) {
    nickname += EMAIL;
  }

  if (smsEnabled) {
    if (nickname.length > 0) {
      nickname += ',';
    }
    nickname += SMS;
  }

  return nickname;
}

function parseEmail(profile) {
  return _.get(profile, 'user_metadata.email', '');
}

function parsePhone(profile) {
  return _.get(profile, 'user_metadata.phone', '');
}

const emailIsValid = (email) => {
  return EmailValidator.validate(email);
};

const phoneIsValid = (phone) => {
  return isValidPhoneNumber(phone);
};

function parseProfile(profile) {
  return {
    email: parseEmail(profile),
    phone: parsePhone(profile),
    emailEnabled: parseNickname(EMAIL, profile),
    smsEnabled: parseNickname(SMS, profile),
  }
}

/**
 * Update the session object stored in Local Storage.
 * @param session
 */
const updateLocalStorageSession = (session) => {

  const {accessToken, expiresAt} = session;

  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
  } else {
    localStorage.removeItem('accessToken');
  }
  if (expiresAt) {
    localStorage.setItem('expiresAt', expiresAt);
  } else {
    localStorage.removeItem('expiresAt');
  }
};

/**
 * Parse error and return the error message and whether the
 * session should be cleared.
 * @param error
 * @returns {{message: String, clearSession: boolean}}
 */
function parseError(error) {

  let message = null;
  let clearSession = false;

  if (error.response) {
    console.log({error_1: error});
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.status === 401) {
      clearSession = true;
      message = null;
    } else if (error.response.status >= 300) {
      clearSession = false;
      message = error.response.data.message || 'Unable to contact server'
    }
  } else if (error.request) {
    console.log({error_2: error});
    // The request was made but no response was received.
    // Note: `error.request` is an instance of XMLHttpRequest.
    clearSession = false;
    message = error.message;
  } else {
    console.log({error_3: error});
    // Something happened in setting up the request that triggered an error
    clearSession = false;
    message = error.message;
  }

  return {message, clearSession};
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function formatPxToNumber(px) {
  return Number(px.slice(0, -2));
}

function formatPrice(priceInCents) {
  const price = priceInCents.toString();
  return `${price.slice(0, -2)}.${price.slice(-2)}`;
}

function isElectron() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf(' electron/') > -1;
}

function isDesktop () {
  // TODO
  return true;
}

/**
 * Generate sections IDs and Names.
 * @code Note: Section order is important and should match the site layout.
 *
 * @returns {{}} Sections. E.g:
 * @code {{sectionID: 'Section Name'}, ...}
 */
function getSections() {
  const sections = {};
  sections.hero = ' ';
  sections.features = 'features';
  sections.socialProof = 'stories';
  if (isDesktop()) { // Download only enabled for desktop.
    sections.download = 'download'
  }
  sections.pricing = 'pricing';
  return sections;
}

export {
  capitalize,
  formatPxToNumber,
  resolveNickname,
  parseNickname,
  parseEmail,
  parsePhone,
  emailIsValid,
  phoneIsValid,
  parseProfile,
  parseError,
  updateLocalStorageSession,
  formatPrice,
  isElectron,
  isDesktop,
  getSections
};



// WEBPACK FOOTER //
// ./src/utils/index.js